import { Model } from '../../api';
import { ICON_TYPES } from '../../components/NotificationBox';
import { AMZ_INFO_TXT, PRIMARY_500 } from '../../styles/colors';
import { HeaderIcon } from '../NotCompatibleAmazon/NotCompatibleAmazon.styles';

export enum VariantType {
  NOT_COMPATIBLE,
  BETA_SUPPORT,
}

export const getNotifiedVariantConfigs = {
  [VariantType.NOT_COMPATIBLE]: {
    title: 'results.notCompatible.getNotified.compatibility.title',
    description: 'results.notCompatible.getNotified.compatibility.description',
    signInInfo: 'results.notCompatible.getNotified.compatibility.signInInfo',
    allSet: 'results.notCompatible.getNotified.compatibility.allSet',
    optInBtn: 'results.notCompatible.getNotified.compatibility.optInBtn',
    privacyNotice:
      'results.notCompatible.getNotified.compatibility.privacyNotice',
    amazonIdRequired: true,
  },
  [VariantType.BETA_SUPPORT]: {
    title: 'results.notCompatible.getNotified.betaSupport.title',
    description: 'results.notCompatible.getNotified.betaSupport.description',
    signInInfo: 'results.notCompatible.getNotified.betaSupport.signInInfo',
    allSet: 'results.notCompatible.getNotified.betaSupport.allSet',
    optInBtn: 'results.notCompatible.getNotified.betaSupport.optInBtn',
    privacyNotice:
      'results.notCompatible.getNotified.betaSupport.privacyNotice',
    amazonIdRequired: false,
  },
};

const notCompatibleConfigs = {
  [VariantType.NOT_COMPATIBLE]: {
    headerTitle: 'results.notCompatible.amazon.compatibility.title',
    headerIcon: {
      amazon: <HeaderIcon />,
      ring: <></>,
    },
    description: 'results.notCompatible.amazon.compatibility.description',
    getNotified: getNotifiedVariantConfigs[VariantType.NOT_COMPATIBLE],
  },
  [VariantType.BETA_SUPPORT]: {
    headerTitle: 'results.notCompatible.amazon.betaSupport.title',
    headerIcon: {
      amazon: <HeaderIcon content={ICON_TYPES.INFO} color={AMZ_INFO_TXT} />,
      ring: (
        <HeaderIcon color={PRIMARY_500} content={'\ue9d9'} fontSize="48px" />
      ),
    },
    description: 'results.notCompatible.amazon.betaSupport.description',
    getNotified: getNotifiedVariantConfigs[VariantType.BETA_SUPPORT],
  },
};

const getConfig = (variantType: VariantType = VariantType.NOT_COMPATIBLE) => {
  return notCompatibleConfigs[variantType];
};

export const betaSupportAvailable = (model: Model | undefined) =>
  model?.variants?.some((v) => v.beta_support === 'available');

export default getConfig;
